module.exports = __webpack_public_path__ + "img/id.7d7a9036.png";